import { Action } from '../actions/types'

export type TabulationState = {
  readonly locked: boolean
}

const initialState: TabulationState = {
  locked: false
}

const reducer = (
  state: TabulationState = initialState,
  action: Action
): TabulationState => {
  switch (action.type) {
    case 'TABULATION_SET_LOCK':
      return { ...state, locked: action.payload }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/reducers/tabulation.ts